import { ColoursObj, Icon, Typography } from "@eventr/common-storybook";
import { MarkdownRow } from "home/components/summary/markdownRow";
import { cardTranslation } from "i18n/translateHelpers";
import { RowInfo } from "./rowInfo";
import { CardText } from "./cardText";

interface IRowInfoNotesProps {
  notes: string;
  type?: "card" | "page";
}
export const RowInfoNotes = ({ notes, type }: IRowInfoNotesProps) => {
  if (!notes) return null;
  if (type === "page") {
    return (
      <RowInfo
        start={<Icon name="Edit_Text" iconColour={ColoursObj.core.secondary} />}
        under={<MarkdownRow value={notes} />}
        middle={<Typography variant="bodyBold">{cardTranslation("Additional Information")}</Typography>}
      />
    );
  }
  return (
    <RowInfo
      start={<Icon name="Free_Edit" bubble bubbleColour={ColoursObj.coreBrights.secondary} />}
      middle={<CardText useMarkdown>{notes}</CardText>}
    />
  );
};
